module.exports = __webpack_public_path__ + "static/img/ic_investigator_binoculars.e9905dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b122/ic_investigator_binoculars.png
// module id = AqlT
// module chunks = 0